import { FaStar } from "react-icons/fa";
import { motion } from "framer-motion";

export default function TestimonialCard({ name, role, company, avatar, rating, text, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.1, duration: 0.4 }}
      className="bg-white rounded-2xl border border-gray-100 shadow-md p-6 flex flex-col h-full"
    >
      <div className="flex gap-1 mb-4">
        {Array.from({ length: rating }).map((_, i) => (
          <FaStar key={i} className="text-yellow-400 text-sm" />
        ))}
      </div>
      <p className="text-sm text-slate-500 leading-relaxed flex-1 mb-6 italic">"{text}"</p>
      <div className="flex items-center gap-3">
        <div
          className="w-11 h-11 rounded-full flex items-center justify-center font-bold text-sm shrink-0 text-white"
          style={{ background: "var(--gradient-primary)" }}
        >
          {avatar}
        </div>
        <div>
          <p className="font-semibold text-sm text-slate-800">{name}</p>
          <p className="text-xs text-slate-400">{role}, {company}</p>
        </div>
      </div>
    </motion.div>
  );
}
